import React from 'react';
import styled from '@emotion/styled/macro';
import {css} from '@emotion/react/macro';
import {hexToRgba} from 'utils';

export interface StyleProps {
  error?: boolean;
  disabled?: boolean;
  isFocus?: boolean;
}

export const inputCss = (props: StyleProps) => css`
  width: 100%;
  height: 35px;
  color: #353d45;
  border-radius: 2px;
  border: 1px solid transparent;
  padding: 7px;
  background: ${(props.disabled && hexToRgba('#F9F9F9', '.3')) ||
  '#F9F9F9'} !important;
  box-shadow: ${props.isFocus ? `0 0 3px 0 #26ABE3` : 'none'};
  cursor: ${(props.disabled && 'not-allowed') || 'text'};
  border-color: ${(props.error && '#ff3b30') ||
  (props.disabled && hexToRgba('#d5dadd', '.3')) ||
  (props.isFocus && '#26ABE3') ||
  '#d5dadd'};
  &:hover {
    border-color: ${(props.error && '#ff3b30') ||
    (props.disabled && hexToRgba('#d5dadd', '.3')) ||
    '#26ABE3'};
  }
  &:focus {
    outline: none;
    border-color: ${(props.error && '#ff3b30') ||
    (props.disabled && hexToRgba('#d5dadd', '.3')) ||
    '#26ABE3'};
    box-shadow: ${(props.error && `0 0 3px 0 #ff3b30`) ||
    (props.disabled && `none`) ||
    `0 0 3px 0 #26ABE3`};
  }
`;

export const CustomInput = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>((props, ref) => <input {...props} ref={ref} />);

const Input = styled(CustomInput)<
  React.InputHTMLAttributes<HTMLInputElement> | StyleProps
>`
  ${inputCss}
`;

export default Input;
